import React from 'react';
import PropertyCard from 'components/propertycard';
import Loader from 'components/loader';
import AdComponent from 'components/adcomponent';
import CommonAdComponent from 'components/commonadcomponent';


const PropertiesList = ({ properties, isFetching, history, hideTLC, adPos, isFeatured, isFPR, isFOH, isFBY, isFHP, hideOP, adIndex, adsList, ...props}) => {

        let lst = [];

        if(!isFetching) {
            properties.map((property, i) => {
                property.isFeatured = isFeatured;
                property.isFPR = isFPR;
                property.isFOH = isFOH;
                property.isFBY = isFBY;
                property.isFHP = isFHP;                
                /* if((Array.isArray(adPos) && adPos.includes(i)) || (!Array.isArray(adPos) && adPos === i)){
                    lst.push(
                        <CardAdComponent
                            key={"Add_" + i }
                            classname={props.classname} />
                    )
                } */
                
                lst.push(
                    <PropertyCard
                        key={ property.Id && property.Id !== 0 ? property.Id : i }
                        property={ property }
                        history={ history }
                        hideTLC={hideTLC}
                        hideOP={hideOP}
                        hideAllButtons={isFBY}
                        showNotification={props.showNotification}
                        classname={props.classname} />
                );
                
                return null;
            })
        }

        if(!isFetching && adPos !== undefined && adPos !== null && Array.isArray(adPos)){
            adPos.map((a, i) => {
                if(adsList && adsList.length > i && adsList[i]){
                    lst.splice(a, 0, (<CommonAdComponent key={"Ad_" + a} classname={(props.classname ? props.classname : "prop_card") + (isFPR ? " fpr " : (isFOH ? " foh " : (isFBY ? " fby " : (isFHP ? " fhp " : ("")))))} adObj={adsList[i]} />));    
                }
                else{
                    lst.splice(a, 0, (<AdComponent key={"Ad_" + a} classname={(props.classname ? props.classname : "prop_card") + (isFPR ? " fpr " : (isFOH ? " foh " : (isFBY ? " fby " : (isFHP ? " fhp " : ("")))))} adIndex={adIndex} />));
                }
                
                return null;
            })
        }
        else if(!isFetching && adPos !== undefined && adPos !== null){
            if(adsList && adsList.length > 0 && adsList[0]){
                lst.splice(adPos, 0, (<CommonAdComponent key={"Ad_" + adPos} classname={(props.classname ? props.classname : "prop_card") + (isFPR ? " fpr " : (isFOH ? " foh " : (isFBY ? " fby " : (isFHP ? " fhp " : ("")))))} adObj={adsList[0]} />));
            }
            else{
                lst.splice(adPos, 0, (<AdComponent key={"Ad_" + adPos} classname={(props.classname ? props.classname : "prop_card") + (isFPR ? " fpr " : (isFOH ? " foh " : (isFBY ? " fby " : (isFHP ? " fhp " : ("")))))} adIndex={adIndex} />));
            }            
        }   

        return (
        <div className="prop_search_list">
        {/*<div className="new_searchlist">*/}
            { isFetching && <Loader message={'Loading properties...'} /> }
            { lst }
        </div>);
    }

export default PropertiesList;
